import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "../Base";

export const GET_REPORT = "GET_REPORT";

@Component
export default class CompetitorsReport extends Base {
  getCompetitorsReport(
    profileSlug: string,
    media: string,
    filter: { date: string; weeklyData: boolean; agentModuleView?: string },
    tag: string,
    grpTarget: string
  ) {
    let queryString = "";
    if (filter.weeklyData) {
      queryString = this.paramsToQueryString({
        date: this.$moment(filter.date)
          .subtract(6, "days")
          .format("YYYY-MM-DD"),
        ends_at: filter.date,
        starts_at: this.$moment(filter.date)
          .subtract(6, "days")
          .format("YYYY-MM-DD"),
        period: "weekly",
        grp_target: grpTarget,
        agent_module_view: filter.agentModuleView,
      });
    } else {
      queryString = this.paramsToQueryString({
        date: filter.date,
        period: "daily",
        grp_target: grpTarget,
        agent_module_view: filter.agentModuleView,
      });
    }
    const url =
      API_ENDPOINT + `/${profileSlug}/${media}/competitors.json?${queryString}`;
    return this.$store.dispatch("http/request", {
      tag,
      url,
      method: "GET",
    });
  }

  getCompetitorsExcelUrl(
    profileSlug: string,
    media: string,
    filter: { date: string; weeklyData: boolean; agentModuleView?: string },
    grpTarget: string
  ) {
    let queryString = "";
    if (filter.weeklyData) {
      queryString = this.paramsToQueryString({
        date: this.$moment(filter.date)
          .subtract(6, "days")
          .format("YYYY-MM-DD"),
        ends_at: filter.date,
        starts_at: this.$moment(filter.date)
          .subtract(6, "days")
          .format("YYYY-MM-DD"),
        period: "weekly",
        grp_target: grpTarget,
        agent_module_view: filter.agentModuleView,
      });
    } else {
      queryString = this.paramsToQueryString({
        date: filter.date,
        period: "daily",
        grp_target: grpTarget,
        agent_module_view: filter.agentModuleView,
      });
    }
    return (
      API_ENDPOINT + `/${profileSlug}/${media}/competitors.xlsx?${queryString}`
    );
  }
}
